import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 18088 18178"
    {...props}
  >
    <defs>
      <style>{".fil0{fill:#2b2a29}"}</style>
    </defs>
    <g id="Layer_x0020_1">
      <g id="_2528320130352">
        <path
          d="M6678 12329c-197 0-392-50-576-148-56-29-91-88-91-150l1-11861c0-94 75-170 170-170h1560c94 0 170 76 170 170v10923c0 682-554 1236-1234 1236zm-326-408c106 43 215 65 326 65 491 0 893-401 893-893V340H6352v11581z"
          className="fil0"
        />
        <path
          d="M5118 13462c-681 0-1234-553-1234-1234V170c0-94 76-170 170-170h2128c94 0 170 76 170 170v12058c0 681-554 1234-1234 1234zM4226 340v11888c0 492 400 894 894 894 492 0 894-402 894-894V340H4226z"
          className="fil0"
        />
        <path
          d="M3560 12329c-680 0-1234-554-1234-1234V170c0-94 76-170 170-170h1560c95 0 170 76 170 170v11859c0 64-35 121-90 150-184 98-379 150-576 150zM2667 340v10755c0 492 399 893 893 893 111 0 219-22 326-65V342H2667v-2zM15594 16145H2496c-94 0-170-76-170-170v-3068c0-95 76-170 170-170 95 0 171 75 171 170v2898h12757v-2898c0-95 75-170 170-170 94 0 170 75 170 170v3068c0 94-76 170-170 170z"
          className="fil0"
        />
        <path
          d="M16668 16145H1420c-94 0-170-76-170-170V170c0-94 76-170 170-170h15248c94 0 170 76 170 170v15805c0 94-76 170-170 170zm-15076-340h14905V340H1592v15465z"
          className="fil0"
        />
        <path
          d="M11410 12329c-680 0-1234-554-1234-1234V170c0-94 76-170 170-170h1560c95 0 170 76 170 170v11859c0 64-34 121-90 150-184 98-377 150-576 150zM10517 340v10755c0 492 399 893 893 893 111 0 220-22 326-65V342h-1219v-2z"
          className="fil0"
        />
        <path
          d="M12970 13462c-680 0-1234-553-1234-1234V170c0-94 76-170 170-170h2128c94 0 170 76 170 170v12058c0 681-553 1234-1234 1234zM12076 340v11888c0 492 400 894 894 894 492 0 894-402 894-894V340h-1788z"
          className="fil0"
        />
        <path
          d="M14530 12329c-197 0-392-50-576-148-56-29-90-88-90-150V170c0-94 76-170 170-170h1560c94 0 170 76 170 170v10923c0 682-554 1236-1234 1236zm-326-408c106 43 215 65 326 65 492 0 894-401 894-893V340h-1220v11581zM17918 18178h-1250c-95 0-171-76-171-170s76-170 171-170h1080v-1693H340v1693h1080c95 0 171 76 171 170s-76 170-171 170H170c-94 0-170-76-170-170v-2033c0-94 76-170 170-170h17748c94 0 170 76 170 170v2033c0 94-76 170-170 170z"
          className="fil0"
        />
        <path
          d="M1988 18178h-568c-94 0-170-76-170-170s76-170 170-170h568c94 0 170 76 170 170s-76 170-170 170zM15016 18178h-1085c-94 0-170-76-170-170s76-170 170-170h1085c94 0 170 76 170 170s-76 170-170 170zm-2171 0h-1086c-95 0-170-76-170-170s75-170 170-170h1086c94 0 170 76 170 170-2 94-78 170-170 170zm-2173 0H9586c-94 0-170-76-170-170s76-170 170-170h1086c95 0 171 76 171 170s-76 170-171 170zm-2170 0H7415c-94 0-170-76-170-170s76-170 170-170h1087c94 0 170 76 170 170s-76 170-170 170zm-2171 0H5245c-94 0-170-76-170-170s76-170 170-170h1086c95 0 170 76 170 170s-75 170-170 170zm-2170 0H3075c-95 0-171-76-171-170s76-170 171-170h1086c94 0 170 76 170 170s-78 170-170 170zM16668 18178h-568c-94 0-170-76-170-170s76-170 170-170h568c94 0 170 76 170 170s-76 170-170 170z"
          className="fil0"
        />
      </g>
    </g>
  </svg>
)
export default SvgComponent
